// Media URL helper — prepends REACT_APP_BACKEND_URL for uploaded files stored as /api/uploads/...
export function mediaUrl(u) {
  if (!u) return "";
  if (typeof u !== "string") return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
}

// YouTube/Vimeo detection for previews
export function isYouTube(u = "") {
  return /(?:youtube\.com|youtu\.be)/i.test(u);
}
export function isYouTubeShort(u = "") {
  return /youtube\.com\/shorts\//i.test(u);
}
export function isVimeo(u = "") {
  return /vimeo\.com/i.test(u);
}
export function isVideoFile(u = "") {
  return /\.(mp4|webm|mov|m4v|avi)(\?|$)/i.test(u) || (u.startsWith("/api/uploads/") && /\.(mp4|webm|mov|m4v|avi)$/i.test(u));
}

// Extract the raw YouTube ID from any known URL shape (watch, youtu.be, shorts, live, embed)
export function getYouTubeId(u = "") {
  if (!u) return "";
  const patterns = [
    /youtube\.com\/shorts\/([\w-]{6,})/i,
    /youtube\.com\/live\/([\w-]{6,})/i,
    /youtube\.com\/embed\/([\w-]{6,})/i,
    /youtube\.com\/watch\?v=([\w-]{6,})/i,
    /youtu\.be\/([\w-]{6,})/i,
  ];
  for (const p of patterns) {
    const m = u.match(p);
    if (m) return m[1];
  }
  return "";
}

export function ytThumbnail(u = "") {
  const id = getYouTubeId(u);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}

export function toEmbed(u = "") {
  if (!u) return "";
  if (u.includes("player.vimeo.com")) return u;
  const ytId = getYouTubeId(u);
  if (ytId) return `https://www.youtube.com/embed/${ytId}`;
  const vim = u.match(/vimeo\.com\/(\d+)/);
  if (vim) return `https://player.vimeo.com/video/${vim[1]}`;
  return u;
}
